import React, { useEffect, useState } from "react";
import "../AdminNewPage/Style/NewDashBoard.css";
import { COLOR, FONT, IMAGE } from "../../../Config/Color";
import { ImageUrl } from "../../../Config/Image";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { format } from "date-fns";
import { Chart } from "primereact/chart";
import AddEmployeeModal from "../../AdminComponent/AddEmployeeModal";
import Card from "../../../Component/Card";
import EmployeeLeaveTable from "./Component/EmployeeLeaveTable";
import ReactApexChart from "react-apexcharts";
import MainLayout from "../../../../layouts/MainLayout";
import {
  getEmployeeProfile,
  getHolidayData,
  getReminder,
} from "../../../../redux/actions/employeeActions";
import {
  getEmployeeAttendanceData,
  getEmployeeData,
} from "../../../../redux/actions/adminAction";
import { setGiftCardShow } from "../../../../redux/actions/normalAction";
import { Api, BaseUrl } from "../../../Config/Api";
import axios from "axios";
import { toast } from "react-toastify";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const NewDashBoard = () => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {};
  const token = sessionStorage.getItem("authToken");
  const employeeId = sessionStorage.getItem("employeeId");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalCardOpen, setModalCardOpen] = useState(false);
  const [cardType, setCardType] = useState("");
  const [cardData, setCardData] = useState([]);
  const currentDate = format(new Date(), "yyyy-MM-dd");
  const currentDate1 = new Date();
  const month = months[currentDate1.getMonth() + 0];
  const day = currentDate1.getDate();
  const [dashboardStats, setDashboardStats] = useState([]);
  const dispatch = useDispatch();
  const [sectionCounts, setSectionCounts] = useState({});
  const error = useSelector((state) => state?.adminData?.error);
  const loading = useSelector((state) => state?.adminData?.loading);
  const getGiftCardShow = useSelector(
    (state) => state?.normalData?.getGiftCardShow
  );

  const reminderData = useSelector((state) => state.employeeData?.reminder);
  const getEmployeeHoliday = useSelector(
    (state) => state.employeeData?.holidayList
  );
  const getProfileData = useSelector((state) => state.employeeData?.profile);

  useEffect(() => {
    dispatch(getEmployeeData());
    dispatch(getEmployeeAttendanceData());
    dispatch(getReminder());
    dispatch(getHolidayData());
    dispatch(getEmployeeProfile(employeeId));
    getDashboardStats();
    getDashboardCounts()
  }, []);

 
  useEffect(() => {
    if (getEmployeeHoliday?.length > 0) {
      getHolidatData(getEmployeeHoliday);
    }
  }, [getEmployeeHoliday]);
  useEffect(() => {
    const date = new Date(getProfileData?.dob);
    const month1 = date.toLocaleString("default", { month: "long" });
    const day1 = date.getDate();
    const date1 = new Date(getProfileData?.doj);
    const month2 = date1.toLocaleString("default", { month: "long" });
    const day2 = date1.getDate();
    if (month1 === month && day1 === day && getGiftCardShow == false) {
      setCardType("BIRTHDAY");
      setCardData(getProfileData);
      openGift();
    } else if (month2 === month && day2 === day && getGiftCardShow == false) {
      setCardType("Work Anniversary");
      setCardData(getProfileData);
      openGift();
    }
  }, [getProfileData]);

  const getHolidatData = (data) => {
    const todayHoliday = data?.find((holiday) => holiday?.date === currentDate);

    if (todayHoliday != undefined && getGiftCardShow == false) {
      setCardType(todayHoliday?.holiday_name);
      setCardData(todayHoliday);
      openGift();
    }
  };
  const openGift = () => {
    setModalCardOpen(true);
  };

 
 

  const [chartData, setChartData] = useState({
    labels: ["Leave", "Late", "WFH", "On time", "Half-day", "Present"],
    datasets: [
      {
        label: "Employee",
        data: [40, 20, 30, 10, 0],
        backgroundColor: [
          "#03C95A",
          "#FFC107",
          "green",
          "#0C4B5E",
          "#E70D0D",
        ],
        borderWidth: 5,
        borderRadius: 10,
        borderColor: "#fff",
        hoverBorderWidth: 0,
        cutout: "60%",
      },
    ],
  });
  const [chartOptions, setChartOptions] = useState({
    rotation: -100,
    circumference: 200,
    layout: {
      padding: {
        top: -20,
        bottom: -20,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  });

  const [empDepartment, setEmpDepartment] = useState({
    chart: {
      height: 400,
      width: 250,
      type: "bar",
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      toolbar: {
        show: false,
      },
    },
    fill: {
      colors: ["#1b84ff"], // Fill color for the bars
      opacity: 1, // Adjust opacity (1 is fully opaque)
    },
    colors: ["#047EFF"],
    grid: {
      borderColor: "#E5E7EB",
      // strokeDashArray: 5,
      padding: {
        top: -20,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
        // barHeight: "50%",
        endingShape: "rounded",
        horizontal: false
      },
      // bar: {
      // }
    },
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        data: [],
        name: "Employee",
      },
    ],
    xaxis: {
      categories: [],
      labels: {
        style: {
          colors: "#111827",
          fontSize: "13px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return Number.isInteger(val) ? val : '';
        }
      },
      decimalsInFloat: 0
    },
  });


  const getDashboardStats = async () => {
    try {
      const responseData = await axios.get(
        `${BaseUrl}${Api.GET_DASHBOARD_STATS}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Company-ID": userDetails?.company_id,
          },
        }
      );

      if (responseData?.data?.valid && responseData?.data?.success) {
        const data = responseData?.data?.data
        let dep = data?.department_stat?.map((item) => { return item?.department || 0 }) || []
        let empCount = data?.department_stat?.map((item) => { return item?.count }) || []
        setEmpDepartment((prev) => ({
          ...prev,
          series: [
            {
              data: empCount || [6, 10],
              name: "Employee",
            },
          ],
          xaxis: {
            ...prev?.xaxis,
            categories: dep || [
              // "UI/UX",
              // "Development",
              // "Management",
              // "HR",
              "Testing",
              "Marketing",
            ],
          }

        }))

        const attendanceCount = Object.entries(data?.attendance_stat)?.filter(([key, value]) => {
          return key != "present"
        })?.map(([key, value]) => {
          //console.log(value ,key);
          return value?.count
        })


        setChartData((prev) => ({
          ...prev,
          datasets: [
            {
              label: "Employee",
              data: attendanceCount,
              backgroundColor: [
                "#E70D0D",
                "#FFC107",
                "#9370DB",
                "#03C95A",
                // "#03C95A",
                "#1E40AF",
              ],
              borderWidth: 5,
              borderRadius: 10,
              borderColor: "#fff",
              hoverBorderWidth: 0,
              cutout: "60%",
            },
          ]
        }))
        // //console.log(responseData?.data?.data);

        setDashboardStats(responseData?.data?.data);
      } else {
        toast.error(error.response.data?.message || error.message);
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };

  const getDashboardCounts = async () => {
    try {
      const responseData = await axios.get(
        `${BaseUrl}dashboard_data`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Company-ID": userDetails?.company_id,
          },
        }
      );
      // console.log(responseData);
      if (responseData?.data?.valid && responseData?.data?.success) {
        // console.log(responseData);
        setSectionCounts(responseData?.data);
      } else {
        toast.error(error.response.data?.message || error.message);
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };


  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          <div className="dashboard">
            <header className="dash-header mb-3">
              <span>👋 Welcome, {getProfileData?.name}</span>
              <div
                style={{
                  width: 100,
                  height: 32,
                  borderRadius: 20,
                  borderWidth: 1,
                  borderColor: "#047EFF",
                  marginLeft: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#E6F2FF",
                }}
              >
                <img
                  src={IMAGE.MEDAL}
                  style={{
                    width: "15px",
                    height: "18px",
                  }}
                />
                <span
                  style={{
                    fontFamily: FONT.INTER,
                    fontWeight: "500",
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#047EFF",
                    marginLeft: "5px",
                  }}
                >
                  Admin
                </span>
              </div>
            </header>

            <div className="card-row">
              <div className="card-container">
                <div className="card flex-fill " style={{ width: "100%" }}>
                  <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                    <h5 className="mb-2">Attendance Overview</h5>
                  </div>
                  <div className="card-body py-2 px-3">
                    <div className="chartjs-wrapper-demo position-relative mb-3 small-chart-wrapper">
                      <Chart
                        type="doughnut"
                        data={chartData}
                        options={chartOptions}
                        className="small-chart"
                        style={{ width: "150px", height: "150px" }}
                      />
                      <div className="position-absolute text-center attendance-canvas">
                        <p className="fs-13 mb-1">Total Attendance</p>
                        <h5>{dashboardStats?.attendance_stat?.present?.count || 0} / {dashboardStats?.total_active_employees}</h5>
                      </div>
                    </div>
                    <h6 className="mb-2">Status</h6>

                    <div className="d-flex align-items-center justify-content-between">
                      <p className="f-13 mb-2">
                        <i className="ti ti-circle-filled text-success me-1" />{" "}
                        On Time
                      </p>
                      <p className="f-13 fw-medium text-gray-9 mb-2">
                        {
                          dashboardStats?.attendance_stat?.on_time?.per
                        }
                        %</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="f-13 mb-2">
                        <i style={{ color: "#FFC107" }} className="ti ti-circle-filled me-1" />{" "}
                        Late
                      </p>
                      <p className="f-13 fw-medium text-gray-9 mb-2"> {
                        dashboardStats?.attendance_stat?.late?.per
                      }%</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="f-13 mb-2">
                        <i style={{ color: "#9370DB" }} className="ti ti-circle-filled me-1" />{" "}
                        WFH
                      </p>
                      <p className="f-13 fw-medium text-gray-9 mb-2">
                        {
                          dashboardStats?.attendance_stat?.wfh?.per
                        }%</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="f-13 mb-2">
                        <i style={{ color: "#DE232A" }} className="ti ti-circle-filled  me-1" />{" "}
                        Leave
                      </p>
                      <p className="f-13 fw-medium text-gray-9 mb-2"> {
                        dashboardStats?.attendance_stat?.leave?.per
                      }%</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <p className="f-13 mb-2">
                        <i style={{ color: "#1E40AF" }} className="ti ti-circle-filled  me-1" />{" "}
                        Half-Day
                      </p>
                      <p className="f-13 fw-medium text-gray-9 mb-2"> {
                        dashboardStats?.attendance_stat?.half_day?.per
                      }%</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-container">
                <div className="card flex-fill " style={{ width: "100%" }}>
                  <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                    <h5 className="mb-2">Employees By Department</h5>
                  </div>
                  <div className="card-body d-flex align-items-center" >

                    {
                      dashboardStats?.department_stat == null ||
                        dashboardStats?.department_stat[0]?.department == null ||
                        dashboardStats?.department_stat?.length == 0 ?
                        <div
                          className="w-full"
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}///Assets/NewImage/Dumy.png
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No Department found !
                          </p>
                        </div> :
                        <ReactApexChart
                          id="emp-department"
                          options={empDepartment}
                          series={empDepartment.series}
                          type="bar"
                          width={250}
                          height={300}
                        />
                    }


                  </div>
                </div>
              </div>

              <div className="card-container">
                <div
                  className="card flex-fill shadow-sm border-0 rounded-3"
                  style={{ maxWidth: "400px", width: "100%" }}
                >
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center flex-wrap">
                    <h5 className="mb-2 fw-bold">Employee Status</h5>
                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <p className="fs-14 text-muted mb-0">Total Employees</p>
                      <h3 className="mb-0 fw-semibold text-dark">{dashboardStats?.total_employees}</h3>
                    </div>
                    <div
                      className="progress-stacked emp-stack mb-4 rounded overflow-hidden"
                      style={{ marginTop: "20px", display: "flex", height: "20px" }}
                    >
                      {dashboardStats?.employee_status_stat?.map((item, index) => {
                        const total = dashboardStats?.total_employees || 1; // Avoid division by 0
                        const widthPercent = ((item.count / total) * 100).toFixed(2) + "%";
                        // //console.log("widthPercent" ,item ,item?.status  ,widthPercent);
                        // Assign color based on status
                        const bgColor =
                          item.status == "Full Time"
                            ? "bg-success"
                            : item.status === "Inactive"
                              ? "bg-secondary"
                              : item.status === "Intern"
                                ? "bg-pink"
                                : "bg-danger"; // Default for Probation

                        return (
                          <div
                            key={index}
                            className="progress"
                            style={{ width: widthPercent }}
                          >
                            <div
                              className={`progress-bar ${bgColor}`}
                              role="progressbar"
                              style={{ width: "100%" }}
                            />
                          </div>
                        );
                      })}
                    </div>

                    <div
                      className="row g-1 border rounded mb-4"
                      style={{ marginTop: "50px" }}
                    >
                      {dashboardStats?.employee_status_stat?.map(
                        (item, index) => {
                          const iconClass =
                            item?.status == "Full Time"
                              ? "ti ti-square-filled text-success fs-12 me-2"
                              : item?.status == "Inactive"
                                ? "ti ti-square-filled me-2 text-secondary fs-12"
                                : item?.status === "Intern"
                                  ? "ti ti-square-filled text-pink me-2 fs-12"
                                  : "ti ti-square-filled me-2 text-danger fs-12";

                          return (
                            <div
                              key={index}
                              className="col-6 border-end border-bottom p-3"
                            >
                              <p className="fs-13 mb-2 text-muted">
                                <i className={`${iconClass} me-2`} />
                                {item?.status || ""}{" "}
                              </p>
                              <h5 className="fw-bold text-dark mb-0">
                                {" "}
                                {item?.count || 0}
                              </h5>
                            </div>
                          );
                        }
                      )}


                    </div>
                  </div>
                </div>
              </div>

              <div className="card-container">
                <div className="card flex-fill ">
                  <div className="row p-4 for-img-set">
                    <div className="col-8">
                      <h2>
                        Grow Your Team, Grow Your Success!
                      </h2>
                      <p className="fs-14 py-2">
                        Easily onboard new talent and keep your workforce
                        thriving. Add new employee with just a click.
                      </p>
                      <button
                        className="btn btn-primary py-1"
                        onClick={() => setModalOpen(true)}
                      >
                        Add Employee
                      </button>
                    </div>
                    <div className="col-12 d-flex justify-content-end demo-image">
                      <img
                        src={ImageUrl.ADDEMPLOYEE}
                        alt="Add Employee"
                        style={{
                          // position: "absolute",
                          width: "160px",
                          height: "138px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                height: "272px",
                marginTop: "16px",
                display: "flex",

                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "49%",
                  height: "100%",
                  borderRadius: "8px",
                  background: "white",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  flexShrink: 0,
                  overflowY: "auto",
                  maxHeight: "270px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div style={{ width: "95%", height: 240 }}>
                  <div
                    style={{
                      width: "100%",
                      height: 48,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex", // Add this
                        gap: "8px",
                        justifyContent: "center", // Center horizontally
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          background: "#F8F8F8",
                          borderRadius: "6px",
                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <img
                          src={ImageUrl.CALENDER}
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          // width: "32px",
                          height: "32px",

                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <h2
                          style={{
                            marginLeft: "8px",
                            fontWeight: "600",
                            fontSize: "16px",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK2,
                          }}
                        >
                          On Leave/WFH Today
                        </h2>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "42px",
                        height: "28px",
                        background: "#F8F8F8",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 5,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          lineHeight: "20px",
                          fontWeight: "500",
                          fontSize: "14px",
                          //fontFamily: "Inter",
                          color: COLOR.BLACK2,
                        }}
                      >

                        {
                          sectionCounts?.today_wfhLeave_count
                        }
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: 1.5,
                      background: "#EDEDED",
                      marginTop: "-5px",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "175px",
                      marginTop: "16px",
                      borderRadius: "4px",
                      background: COLOR.GRAY,
                      overflowY: "auto", // Enables vertical scrolling
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                      }}
                    >
                      {sectionCounts?.today_wfhLeave?.length > 0 ? (
                        sectionCounts?.today_wfhLeave?.map((leaveItem, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                flexDirection: "row",
                                padding: 10,
                                paddingRight: 20,
                                justifyContent: "space-between",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ display: "flex" }}>
                                <span
                                  style={{
                                    color:
                                      leaveItem.attendance_status === "Leave"
                                        ? "#B91C1C"
                                        : leaveItem.attendance_status ===
                                          "Half-Day"
                                          ? "#1E40AF"
                                          : "#9370DB",
                                  }}
                                >
                                  ●
                                </span>
                                <h3
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: "600",
                                    color: COLOR.BLACK2,
                                    fontSize: "14px",
                                    //fontFamily: "Inter",
                                  }}
                                >
                                  {leaveItem.name}
                                </h3>
                              </div>

                              <div style={{ display: "flex", gap: "10px" }}>
                                {/* Attendance Status Display (Leave) */}

                                {leaveItem.attendance_status === "Leave" && (
                                  <div
                                    style={{
                                      width: "80px",
                                      height: "25px",
                                      color: "#B91C1C",
                                      background: "#FECACA",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "30px",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      paddingTop: 3,
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                        lineHeight: "1",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#B91C1C",
                                          fontSize: "14px",
                                        }}
                                      >
                                        ●
                                      </span>
                                      {leaveItem.attendance_status}
                                    </span>
                                  </div>
                                )}
                                {leaveItem.work_status == "WFH" && (
                                  <div
                                    style={{
                                      width: "80px",
                                      height: "25px",
                                      color: "#115E59",
                                      background: "#F7EEFC",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "30px",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      paddingTop: 3,
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                        color: "#9370DB",
                                        lineHeight: "1",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#9370DB",
                                          fontSize: "14px",
                                        }}
                                      >
                                        ●
                                      </span>
                                      {leaveItem.work_status}
                                    </span>
                                  </div>
                                )}
                                {leaveItem?.attendance_status ==
                                  "Half-Day" && (
                                    <div
                                      style={{
                                        width: "80px",
                                        height: "25px",
                                        color: "#1E40AF",
                                        background: "#b0c3ff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "30px",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "5px",
                                          lineHeight: "1",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#1E40AF",
                                            fontSize: "14px",
                                          }}
                                        >
                                          ●
                                        </span>
                                        {leaveItem.attendance_status}
                                      </span>
                                    </div>
                                  )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No one on leave or WFH today.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "49%",
                  height: "100%",
                  borderRadius: "8px",
                  background: "white",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  flexShrink: 0,
                  overflowY: "auto",
                  maxHeight: "270px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div style={{ width: "95%", height: 240 }}>
                  <div
                    style={{
                      width: "100%",
                      height: 48,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex", // Add this
                        gap: "8px",
                        justifyContent: "center", // Center horizontally
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          background: "#F8F8F8",
                          borderRadius: "6px",
                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <img
                          src={ImageUrl.CAKE}
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          // width: "32px",
                          height: "32px",

                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <h2
                          style={{
                            marginLeft: "8px",
                            fontWeight: "600",
                            fontSize: "16px",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK2,
                          }}
                        >
                          Birthday’s This Month
                        </h2>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "42px",
                        height: "28px",
                        background: "#F8F8F8",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 5,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          lineHeight: "20px",
                          fontWeight: "500",
                          fontSize: "14px",
                          //fontFamily: "Inter",
                          color: COLOR.BLACK2,
                        }}
                      >
                        {reminderData?.current_events?.length > 0 ||
                          reminderData?.upcoming_events?.length > 0
                          ? (() => {
                            // Filter and combine the data
                            const birthdayItems = [
                              ...(reminderData?.current_events || []),
                              ...(reminderData?.upcoming_events || []),
                            ].filter((item) => {
                              if (item.type !== "Birthday") return false;

                              const itemDate = new Date(item.date);
                              const currentMonth = new Date().getMonth();
                              const currentYear = new Date().getFullYear();

                              return (
                                itemDate.getMonth() === currentMonth &&
                                itemDate.getFullYear() === currentYear
                              );
                            });

                            return birthdayItems?.length;
                          })()
                          : 0}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: 1.5,
                      background: "#EDEDED",
                      marginTop: "-5px",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "175px",
                      marginTop: "16px",
                      borderRadius: "4px",
                      background: COLOR.GRAY,
                      overflowY: "auto", // Enables vertical scrolling
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                      }}
                    >
                      {reminderData?.current_events?.length > 0 ||
                        reminderData?.upcoming_events?.length > 0 ? (
                        (() => {
                          const birthdayItems = [
                            ...(reminderData?.current_events || []),
                            ...(reminderData?.upcoming_events || []),
                          ].filter((item) => {
                            if (item.type !== "Birthday") return false;

                            const itemDate = new Date(item.date);
                            const currentMonth = new Date().getMonth();
                            const currentYear = new Date().getFullYear();

                            return (
                              itemDate.getMonth() === currentMonth &&
                              itemDate.getFullYear() === currentYear
                            );
                          });

                          return birthdayItems.length > 0 ? (
                            birthdayItems.map((birthdayItem, index) => {
                              const date = new Date(birthdayItem.date);
                              const day = new Intl.DateTimeFormat("en-US", {
                                weekday: "long",
                              }).format(date);

                              return (
                                <div
                                  key={index}
                                  style={{
                                    width: "100%",
                                    flexDirection: "row",
                                    padding: 10,
                                    paddingRight: 20,
                                    justifyContent: "space-between",
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "40%",
                                      alignItems: "flex-start",
                                      justifyContent: "flex-start",
                                      display: "flex",
                                    }}
                                  >
                                    <span style={{ color: "#115E59" }}>●</span>
                                    <h3
                                      style={{
                                        marginLeft: "10px",
                                        fontWeight: "600",
                                        color: COLOR.BLACK2,
                                        fontSize: "14px",
                                        //fontFamily: "Inter",
                                      }}
                                    >
                                      {birthdayItem?.name}
                                    </h3>
                                  </div>
                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#115E59",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {birthdayItem?.date}
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        color: "#115E59",
                                        alignItems: "center",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {day}
                                    </span>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                display: "flex", // Add this line
                                flexDirection: "column", // Add this line to stack items vertically
                                color: "#888888",
                                fontWeight: "600",
                                marginTop: "20px",
                                justifyContent: "center",
                                alignItems: "center",
                                // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                              }}
                            >
                              <img
                                src={ImageUrl.NODATA}
                                style={{
                                  width: "50px",
                                  height: "50px",
                                }}
                              />
                              <p
                                style={{
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  //fontFamily: "Inter",
                                  color: COLOR.GRAY1,
                                }}
                              >
                                No birthdays this month.
                              </p>
                            </div>
                          );
                        })()
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No events data available.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "272px",
                marginTop: "16px",
                display: "flex",

                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "49%",
                  height: "100%",
                  borderRadius: "8px",
                  background: "white",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  flexShrink: 0,
                  overflowY: "auto",
                  maxHeight: "270px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div style={{ width: "95%", height: 240 }}>
                  <div
                    style={{
                      width: "100%",
                      height: 48,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex", // Add this
                        gap: "8px",
                        justifyContent: "center", // Center horizontally
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          background: "#F8F8F8",
                          borderRadius: "6px",
                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <img
                          src={ImageUrl.WATCH}
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          // width: "32px",
                          height: "32px",

                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <h2
                          style={{
                            marginLeft: "8px",
                            fontWeight: "600",
                            fontSize: "16px",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK2,
                          }}
                        >
                          Late's Today
                        </h2>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "42px",
                        height: "28px",
                        background: "#F8F8F8",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 5,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          lineHeight: "20px",
                          fontWeight: "500",
                          fontSize: "14px",
                          //fontFamily: "Inter",
                          color: COLOR.BLACK2,
                        }}
                      >
                        {
                          sectionCounts?.late_today_count
                        }
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: 1.5,
                      background: "#EDEDED",
                      marginTop: "-5px",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "175px",
                      marginTop: "16px",
                      borderRadius: "4px",
                      background: COLOR.GRAY,
                      overflowY: "auto", // Enables vertical scrolling
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                      }}
                    >
                      {Array.isArray(sectionCounts?.late_today) &&
                        sectionCounts?.late_today.length > 0  ? (
                        sectionCounts?.late_today.map((leaveItem, index) => (
                          <div
                            key={index}
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              padding: 10,
                              paddingRight: 20,
                              justifyContent: "space-between",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ display: "flex" }}>
                              <span style={{ color: "#FFCC00" }}>●</span>
                              <h3
                                style={{
                                  marginLeft: "10px",
                                  fontWeight: "600",
                                  color: COLOR.BLACK2,
                                  fontSize: "14px",
                                  //fontFamily: "Inter",
                                }}
                              >
                                {leaveItem.name}
                              </h3>
                            </div>

                            <div style={{ display: "flex", gap: "10px" }}>
                              {leaveItem.attendance_status === "Late" && (
                                <div
                                  style={{
                                    // background: "#FECACA",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "80px",
                                    height: "25px",
                                    borderRadius: "30px",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "50px",
                                      lineHeight: "1",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#2D3142",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                      }}
                                    ></span>

                                    {leaveItem?.login_time}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No late attendance records found
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "49%",
                  height: "100%",
                  borderRadius: "8px",
                  background: "white",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  flexShrink: 0,
                  overflowY: "auto",
                  maxHeight: "270px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div style={{ width: "95%", height: 240 }}>
                  <div
                    style={{
                      width: "100%",
                      height: 48,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex", // Add this
                        gap: "8px",
                        justifyContent: "center", // Center horizontally
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          background: "#F8F8F8",
                          borderRadius: "6px",
                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <img
                          src={ImageUrl.MILESTONE}
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          // width: "32px",
                          height: "32px",

                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <h2
                          style={{
                            marginLeft: "8px",
                            fontWeight: "600",
                            fontSize: "16px",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK2,
                          }}
                        >
                          Milestone's This Month
                        </h2>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "42px",
                        height: "28px",
                        background: "#F8F8F8",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 5,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          lineHeight: "20px",
                          fontWeight: "500",
                          fontSize: "14px",
                          //fontFamily: "Inter",
                          color: COLOR.BLACK2,
                        }}
                      >
                        {reminderData?.current_events?.length > 0 ||
                          reminderData?.upcoming_events?.length > 0
                          ? (() => {
                            // Filter and combine the data
                            const birthdayItems = [
                              ...(reminderData?.current_events || []),
                              ...(reminderData?.upcoming_events || []),
                            ].filter((item) => {
                              if (item.type !== "Anniversary") return false;

                              const itemDate = new Date(item.date);
                              const currentMonth = new Date().getMonth();
                              const currentYear = new Date().getFullYear();

                              return (
                                itemDate.getMonth() === currentMonth &&
                                itemDate.getFullYear() === currentYear
                              );
                            });

                            return birthdayItems?.length;
                          })()
                          : 0}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: 1.5,
                      background: "#EDEDED",
                      marginTop: "-5px",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "175px",
                      marginTop: "16px",
                      borderRadius: "4px",
                      background: COLOR.GRAY,
                      overflowY: "auto", // Enables vertical scrolling
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                      }}
                    >
                      {reminderData?.current_events?.length > 0 ||
                        reminderData?.upcoming_events?.length > 0 ? (
                        (() => {
                          const birthdayItems = [
                            ...(reminderData?.current_events || []),

                            ...(reminderData?.upcoming_events || []),
                          ].filter((item) => {
                            if (item.type != "Anniversary") return false;

                            const itemDate = new Date(item.date);
                            const currentMonth = new Date().getMonth();
                            const currentYear = new Date().getFullYear();

                            return (
                              itemDate.getMonth() === currentMonth &&
                              itemDate.getFullYear() === currentYear
                            );
                          });

                          return birthdayItems.length > 0 ? (
                            birthdayItems.map((birthdayItem, index) => {
                              const date = new Date(birthdayItem.date);
                              const day = new Intl.DateTimeFormat("en-US", {
                                weekday: "long",
                              }).format(date);

                              return (
                                <div
                                  key={index}
                                  style={{
                                    width: "100%",
                                    flexDirection: "row",
                                    padding: 10,
                                    paddingRight: 20,
                                    justifyContent: "space-between",
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "40%",
                                      alignItems: "flex-start",
                                      justifyContent: "flex-start",
                                      display: "flex",
                                    }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <span style={{ color: "#115E59" }}>
                                        ●
                                      </span>
                                      <h3
                                        style={{
                                          fontWeight: "600",
                                          color: COLOR.BLACK2,
                                          fontSize: "14px",
                                          //fontFamily: "Inter",
                                          marginLeft: 10,
                                        }}
                                      >
                                        {birthdayItem?.name}({birthdayItem.type}
                                        )
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#115E59",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {birthdayItem?.date}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        color: "#115E59",
                                        alignItems: "center",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {day}
                                    </span>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                display: "flex", // Add this line
                                flexDirection: "column", // Add this line to stack items vertically
                                color: "#888888",
                                fontWeight: "600",
                                marginTop: "25px",
                                justifyContent: "center",
                                alignItems: "center",
                                // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                              }}
                            >
                              <img
                                src={ImageUrl.NODATA}
                                style={{
                                  width: "50px",
                                  height: "50px",
                                }}
                              />
                              <p
                                style={{
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  //fontFamily: "Inter",
                                  color: COLOR.GRAY1,
                                }}
                              >
                                No events this month
                              </p>
                            </div>
                          );
                        })()
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No events this month
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "272px",
                marginTop: "16px",
                display: "flex",

                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "49%",
                  height: "100%",
                  borderRadius: "8px",
                  background: "white",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  flexShrink: 0,
                  overflowY: "auto",
                  maxHeight: "270px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div style={{ width: "95%", height: 240 }}>
                  <div
                    style={{
                      width: "100%",
                      height: 48,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex", // Add this
                        gap: "8px",
                        justifyContent: "center", // Center horizontally
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          background: "#F8F8F8",
                          borderRadius: "6px",
                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <img
                          src={ImageUrl.LATE}
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          // width: "32px",
                          height: "32px",

                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <h2
                          style={{
                            marginLeft: "8px",
                            fontWeight: "600",
                            fontSize: "16px",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK2,
                          }}
                        >
                          Most Lates This Month
                        </h2>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "42px",
                        height: "28px",
                        background: "#F8F8F8",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 5,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          lineHeight: "20px",
                          fontWeight: "500",
                          fontSize: "14px",
                          //fontFamily: "Inter",
                          color: COLOR.BLACK2,
                        }}
                      >
                        {sectionCounts?.late_this_month_count}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: 1.5,
                      background: "#EDEDED",
                      marginTop: "-5px",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "175px",
                      marginTop: "16px",
                      borderRadius: "4px",
                      background: COLOR.GRAY,
                      overflowY: "auto", // Enables vertical scrolling
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                      }}
                    >
                      {Array.isArray(sectionCounts?.late_this_month) &&
                        sectionCounts?.late_this_month.length > 0 ? (
                        sectionCounts?.late_this_month.map((person, index) => (
                          <div
                            key={index}
                            style={{
                              width: "100%",
                              padding: "5px",
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "5px",
                            }}
                          >
                            <div style={{ display: "flex" }}>
                              <span style={{ color: "#FFCC00" }}>●</span>
                              <h3
                                style={{
                                  marginLeft: "10px",
                                  fontWeight: "600",
                                  color: COLOR.BLACK2,
                                  fontSize: "14px",
                                  //fontFamily: "Inter",
                                }}
                              >
                                {person?.name}
                              </h3>
                            </div>
                            <span
                              style={{
                                fontWeight: "600",
                                color: COLOR.BLACK2,
                                fontSize: "14px",
                                //fontFamily: "Inter",
                              }}
                            >
                              {person?.count}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No late records found
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "49%",
                  height: "100%",
                  borderRadius: "8px",
                  background: "white",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  flexShrink: 0,
                  overflowY: "auto",
                  maxHeight: "270px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div style={{ width: "95%", height: 240 }}>
                  <div
                    style={{
                      width: "100%",
                      height: 48,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex", // Add this
                        gap: "8px",
                        justifyContent: "center", // Center horizontally
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          background: "#F8F8F8",
                          borderRadius: "6px",
                          display: "flex", // Add this
                          alignItems: "center", // Center vertically
                          justifyContent: "center", // Center horizontally
                        }}
                      >
                        <img
                          src={ImageUrl.CALENDER1}
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          height: "32px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <h2
                          style={{
                            marginLeft: "8px",
                            fontWeight: "600",
                            fontSize: "16px",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK2,
                          }}
                        >
                          Holiday's This Month
                        </h2>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "42px",
                        height: "28px",
                        background: "#F8F8F8",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 5,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          lineHeight: "20px",
                          fontWeight: "500",
                          fontSize: "14px",
                          //fontFamily: "Inter",
                          color: COLOR.BLACK2,
                        }}
                      >
                        {Array.isArray(getEmployeeHoliday)
                          ? getEmployeeHoliday.filter((item) => {
                            const holidayDate = new Date(item.date);
                            const currentMonth = new Date().getMonth();
                            const currentYear = new Date().getFullYear();
                            return (
                              holidayDate.getMonth() === currentMonth &&
                              holidayDate.getFullYear() === currentYear
                            );
                          }).length
                          : 0}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: 1.5,
                      background: "#EDEDED",
                      marginTop: "-5px",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "175px",
                      marginTop: "16px",
                      borderRadius: "4px",
                      background: COLOR.GRAY,
                      overflowY: "auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                      }}
                    >
                      {getEmployeeHoliday && getEmployeeHoliday?.length > 0 ? (
                        (() => {
                          const currentMonth = new Date().getMonth();
                          const currentYear = new Date().getFullYear();

                          const filteredHolidays = getEmployeeHoliday.filter(
                            (item) => {
                              const holidayDate = new Date(item.date);
                              return (
                                holidayDate.getMonth() === currentMonth &&
                                holidayDate.getFullYear() === currentYear
                              );
                            }
                          );

                          return filteredHolidays.length > 0 ? (
                            filteredHolidays.map((holidayItem, index) => {
                              const date = new Date(holidayItem.date);
                              const day = new Intl.DateTimeFormat("en-US", {
                                weekday: "long",
                              }).format(date);

                              return (
                                <div
                                  key={index}
                                  style={{
                                    width: "100%",
                                    flexDirection: "row",
                                    padding: 10,
                                    paddingRight: 20,
                                    justifyContent: "space-between",
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div style={{ width: "40%" }}>
                                    <div style={{ display: "flex" }}>
                                      <span style={{ color: "#FEAABC" }}>
                                        ●
                                      </span>
                                      <h3
                                        style={{
                                          marginLeft: "10px",
                                          fontWeight: "600",
                                          color: COLOR.BLACK2,
                                          fontSize: "14px",
                                          //fontFamily: "Inter",
                                        }}
                                      >
                                        {holidayItem?.holiday_name}
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#115E59",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {holidayItem?.date}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        color: "#115E59",
                                        alignItems: "center",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {day}
                                    </span>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                display: "flex", // Add this line
                                flexDirection: "column", // Add this line to stack items vertically
                                color: "#888888",
                                fontWeight: "600",
                                marginTop: "20px",
                                justifyContent: "center",
                                alignItems: "center",
                                // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                              }}
                            >
                              <img
                                src={ImageUrl.NODATA}
                                style={{
                                  width: "50px",
                                  height: "50px",
                                }}
                              />
                              <p
                                style={{
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  //fontFamily: "Inter",
                                  color: COLOR.GRAY1,
                                }}
                              >
                                No holiday this month.
                              </p>
                            </div>
                          );
                        })()
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No holiday this month.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginTop: "16px" }}>
              <EmployeeLeaveTable />
            </div>

            <AddEmployeeModal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
            />
            <div>
              <Card
                open={modalCardOpen}
                onClose={() => {
                  setModalCardOpen(false);
                  dispatch(setGiftCardShow(true));
                }}
                data={cardData}
                type={cardType}
              />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default NewDashBoard;
